import { useState, useEffect } from 'react';

interface HelpSidebarProps {
  title: string;
  description: string;
  tips?: string[];
}

export default function HelpSidebar({ title, description, tips }: HelpSidebarProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [autoCollapsed, setAutoCollapsed] = useState(false);

  // Auto-collapse when viewport is narrow
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1200px)');
    const handler = (e: MediaQueryListEvent | MediaQueryList) => {
      setAutoCollapsed(e.matches);
    };
    handler(mq);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const isCollapsed = collapsed || autoCollapsed;

  if (isCollapsed) {
    return (
      <aside className="help-sidebar collapsed">
        <button
          className="help-sidebar-toggle"
          onClick={() => {
            setCollapsed(false);
            setAutoCollapsed(false);
          }}
          title="Show help"
        >
          ?
        </button>
      </aside>
    );
  }

  return (
    <aside className="help-sidebar">
      <div className="help-sidebar-content">
        <div className="help-sidebar-header">
          <h3 className="help-sidebar-title">{title}</h3>
          <button
            className="help-sidebar-close"
            onClick={() => setCollapsed(true)}
            title="Hide help"
          >
            ✕
          </button>
        </div>
        <p className="help-sidebar-desc">{description}</p>

        {tips && tips.length > 0 && (
          <div className="help-sidebar-tips">
            <h4>Tips</h4>
            <ul>
              {tips.map((tip, i) => (
                <li key={i}>{tip}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </aside>
  );
}
